import { observer } from "mobx-react-lite";
import { IconButton } from "@material-ui/core";
import { Star, StarBorder } from "@material-ui/icons";
import { useGlobalStore } from "@hooks";
import { useToggleConsultantFavourite } from "./use-toggle-consultant-favourite";

type Props = {
  consultantId: string;
  className?: string;
  size?: "small" | "medium";
};

export const ConsultantFavouriteToggle = observer(function ConsultantFavouriteToggle({
  consultantId,
  className,
  size = "medium"
}: Props) {
  const { consultantFavourites } = useGlobalStore();
  const { toggle, loading } = useToggleConsultantFavourite();

  const isFavourite = consultantFavourites.has(consultantId);

  return (
    <IconButton
      className={className}
      size={size}
      disabled={loading}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        toggle(consultantId);
      }}
    >
      {isFavourite ? (
        <Star style={{ fill: "gold" }} fontSize={size} />
      ) : (
        <StarBorder fontSize={size} />
      )}
    </IconButton>
  );
});
